export const Bio = {
  name: 'Julia Dooby',
  roles: [
    // 'React Frontend-Разработчик',
    'Fullstack Developer',
    'React Frontend Developer',
    'React Js Developer',
    'Web Js Developer',
  ],
  description:
    'I am a true motivated developer with a passion for creating innovative and effective solutions. My motivation comes from my love of programming and constant exploration of new technologies.  Using my knowledge and development skills, I take every task as a challenge and always strive to achieve the highest quality code.',
  github: 'https://github.com/juliaDooby',
  resume: 'https://hh.ru/resume/5eefba7cff0f34831a0039ed1f685938616b47',
  linkedin: 'https://www.linkedin.com/in/juliadooby',
  // headhunter: 'https://',
  // twitter: 'https://twitter.com/RishavChanda',
  // insta: 'https://www.instagram.com/rishav_chanda/',
  // facebook: 'https://www.facebook.com/rishav.chanda.165/',
  // careerHabr: 'https://career.habr.com/',
};

export const skills = [
  {
    title: 'Frontend',
    skills: [
      {
        name: 'React',
        image:
          'https://github.com/juliaDooby/Clideo/blob/main/assets/images/skill-icons/react.png?raw=true',
      },
      {
        name: 'JavaScript',
        image:
          'https://github.com/juliaDooby/Clideo/blob/main/assets/images/skill-icons/js.png?raw=true',
      },
      {
        name: 'ES6+',
        image:
          'https://github.com/juliaDooby/Clideo/blob/main/assets/images/skill-icons/ES6+.jpeg?raw=true',
      },
      {
        name: 'Async/Await',
        image:
          'https://github.com/juliaDooby/Clideo/blob/main/assets/images/skill-icons/async.png?raw=true',
      },
      {
        name: 'Typescript',
        image: 'https://github.com/juliaDooby/Clideo/blob/main/assets/images/skill-icons/ts.JPG?raw=true',
      },  
      {
        name: 'Redux',
        image:
          'https://github.com/juliaDooby/Clideo/blob/main/assets/images/skill-icons/redux-orig.JPG?raw=true',
      },
      {
        name: 'Redux Toolkit',
        image:
          'https://github.com/juliaDooby/Clideo/blob/main/assets/images/skill-icons/redux.png?raw=true',
      },
      {
        name: 'Redux-Saga',
        image:
          'https://github.com/juliaDooby/Clideo/blob/main/assets/images/skill-icons/redux.png?raw=true',
      },
      {
        name: 'Next',
        image:
          'https://github.com/juliaDooby/Clideo/blob/main/assets/images/skill-icons/next.png?raw=true',
      },
      {
        name: 'React-router',
        image: 'https://github.com/juliaDooby/Clideo/blob/main/assets/images/skill-icons/router.JPG?raw=true',
      },
      {
        name: 'React-router-dom',
        image: 'https://github.com/juliaDooby/Clideo/blob/main/assets/images/skill-icons/router.JPG?raw=true',
      },  
      // {
      //   name: 'MobX',
      //   image: 'https://mobx.js.org/img/mobx.png',
      // },  
      {
        name: 'BEM',
        image:
          'https://github.com/juliaDooby/Clideo/blob/main/assets/images/skill-icons/bem.png?raw=true',
      },
      {
        name: 'HTML5',
        image: 'https://github.com/juliaDooby/Clideo/blob/main/assets/images/skill-icons/html5.png?raw=true',
      },
      {
        name: 'CSS3',
        image:
          'https://github.com/juliaDooby/Clideo/blob/main/assets/images/skill-icons/CSS3.png?raw=true',
      },
      {
        name: 'SCSS',
        image:
          'https://github.com/juliaDooby/Clideo/blob/main/assets/images/skill-icons/sass.png?raw=true',
      },  
      {
        name: 'Airbnb',
        image: 'https://github.com/juliaDooby/Clideo/blob/main/assets/images/skill-icons/airbnb.png?raw=true',
      },
      {
        name: 'ESLint',
        image: 'https://github.com/juliaDooby/Clideo/blob/main/assets/images/skill-icons/eslint.JPG?raw=true',
      }, 
      {
        name: 'Bootstrap',
        image: 'https://github.com/juliaDooby/Clideo/blob/main/assets/images/skill-icons/bootstrap.png?raw=true',
      },
      {
        name: 'Bootstrap-grid',
        image: 'https://github.com/juliaDooby/Clideo/blob/main/assets/images/skill-icons/bootstrap.png?raw=true',
      },    
      {
        name: 'Material UI',
        image:
          'https://github.com/juliaDooby/Clideo/blob/main/assets/images/skill-icons/material-ui.png?raw=true',
      },
      {
        name: 'UIKit',
        image:
          'https://github.com/juliaDooby/Clideo/blob/main/assets/images/skill-icons/uikit.png?raw=true',
      },
      {
        name: 'Tailwind CSS',
        image:
          'https://github.com/juliaDooby/Clideo/blob/main/assets/images/skill-icons/tailwind.png?raw=true',
      },
      {
        name: 'GSAP',
        image:
          'https://github.com/juliaDooby/Clideo/blob/main/assets/images/skill-icons/gsap.JPG?raw=true',
      },
      {
        name: 'Figma',
        image: 'https://github.com/juliaDooby/Clideo/blob/main/assets/images/skill-icons/figma.png?raw=true',
      },
      {
        name: 'Axios',
        image:
          'https://github.com/juliaDooby/Clideo/blob/main/assets/images/skill-icons/axios.png?raw=true',
      },
      {
        name: 'REST API',
        image:
          'https://github.com/juliaDooby/Clideo/blob/main/assets/images/skill-icons/api.jpeg?raw=true',
      },
      {
        name: 'Websockets',
        image:
          'https://github.com/juliaDooby/Clideo/blob/main/assets/images/skill-icons/websockets.png?raw=true',
      },
      {
        name: 'Git',
        image: 'https://github.com/juliaDooby/Clideo/blob/main/assets/images/skill-icons/git.png?raw=true',
      },
      {
        name: 'Webpack',
        image: 'https://github.com/juliaDooby/Clideo/blob/main/assets/images/skill-icons/webpack.png?raw=true',
      },
    ],
  },
  {
    title: 'Backend',
    skills: [
      {
        name: 'Node Js',
        image: 'https://github.com/juliaDooby/Clideo/blob/main/assets/images/skill-icons/node.png?raw=true',
      },
      {
        name: 'Nest Js',
        image:
          'https://github.com/juliaDooby/Clideo/blob/main/assets/images/skill-icons/NestJS.png?raw=true',
      },  
      {
        name: 'Express Js',
        image:
          'https://github.com/juliaDooby/Clideo/blob/main/assets/images/skill-icons/express.png?raw=true',
      },   
      {
        name: 'React Native',
        image:
          'https://github.com/juliaDooby/Clideo/blob/main/assets/images/skill-icons/react.png?raw=true',
      },
      {
        name: 'MongoDB',
        image:
          'https://github.com/juliaDooby/Clideo/blob/main/assets/images/skill-icons/mongodb.png?raw=true',
      },
      {
        name: 'Postman',
        image: 'https://github.com/juliaDooby/Clideo/blob/main/assets/images/skill-icons/postman.JPG?raw=true',
      },
      {
        name: 'PostgreSQL',
        image: 'https://github.com/juliaDooby/Clideo/blob/main/assets/images/skill-icons/postgresq.png?raw=true',
      },
    ],
  },
  {
    title: 'Others',
    skills: [
      {
        name: 'KANBAN',
        image:
          'https://github.com/juliaDooby/Clideo/blob/main/assets/images/skill-icons/kanban.png?raw=true',
      },
      {
        name: 'SCRUM',
        image:
          'https://github.com/juliaDooby/Clideo/blob/main/assets/images/skill-icons/dockervscrum.png?raw=true',
      },
      {
        name: 'UI/Unit test',
        image: 'https://github.com/juliaDooby/Clideo/blob/main/assets/images/skill-icons/test.png?raw=true',
      }, 
      {
        name: 'Docker',
        image:
          'https://github.com/juliaDooby/Clideo/blob/main/assets/images/skill-icons/dockervscrum.png?raw=true',
      },
      {
        name: 'CI/CD',
        image:
          'https://github.com/juliaDooby/Clideo/blob/main/assets/images/skill-icons/cicd.png?raw=true',
      },
      {
        name: 'SOLID',
        image:
          'https://github.com/juliaDooby/Clideo/blob/main/assets/images/skill-icons/solid.jpeg?raw=true',
      },
      {
        name: 'OOP',
        image:
          'https://github.com/juliaDooby/Clideo/blob/main/assets/images/skill-icons/oop.jpeg?raw=true',
      }, 
      {
        name: 'GitHub',
        image:
          'https://github.com/juliaDooby/Clideo/blob/main/assets/images/skill-icons/github.png?raw=true',
      },
      {
        name: 'VS Code',
        image:
          'https://github.com/juliaDooby/Clideo/blob/main/assets/images/skill-icons/vscode.png?raw=true',
      },
      {
        name: 'English language',
        image:
          'https://github.com/juliaDooby/Clideo/blob/main/assets/images/skill-icons/react.png?raw=true',
      },
    ],
  },
];

export const experiences = [
  {
    id: 0,
    img: 'https://github.com/juliaDooby/Clideo/blob/main/assets/images/skill-icons/prod-comp.jpeg?raw=true',
    role: 'Fullstack-developer',
    company: 'Dilligenforce Technology',
    date: 'June 2021 — Present',
    desc: `
A product company that develops websites and applications for clients from Big Tech and related industries (PropTech, E-commerce, Media).
·······················································································································································································
A digital real estate platform for the real estate business: a client website for users and an integrated administrative management system (CRM panel) for internal work with clients, applications, facilities and analytics for the housing market. 
·······················································································································································································
Worked on a website and a mobile application for real estate agents with 500,000 audience per month in the cross-fullstack product team of 8+ people
·······················································································································································································
Progress: 
┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈⏎
─ Developed an algorithm for organizing real estate displays and generating agency reports with filtering, sorting, and object display logic
┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈
─ Expanded the tasks module: added the creation and archiving of applications, uploading documents and communicating with agents through the interface
┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈
─ Set up client logic for evaluating video reviews, saving objects to favorites, and creating personal collections
┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈
─ Optimized and maintained the subscription payment module; implemented authorization via JWT with secure requests and token updates
┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈
─ Carried out refactoring of components and hooks, improved the readability and reusability of the code, documented the architecture of the project
┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈
─ Set up CI/CD pipelines and a testing system (unit, E2E, snapshot) using Jest, RTL and Cypress to increase the stability of releases
·······················································································································································································`,
    skills: [
      ' React',
      ' Next.js',
      ' JavaScript',
      ' Typescript',
      ' Async/Await',
      ' Redux',
      ' Redux Toolkit',
      ' Redux-Saga',
      ' React-router-dom',
      ' Axios',
      ' Rest API',
      ' Git',
      ' Bootstrap',
      ' Bootstrap-grid',
      ' Material-UI',
      ' Tailwind CSS',
      ' HTML5',
      ' CSS3',
      ' SCSS',
      ' SASS',
      ' ESLint',
      ' Webpack',
      ' Backend (basic-exp):',
      ' React Native',
      ' Node.js',
      ' ExpressJS',
      ' Nest.js',
      ' MongoDB',
      ' Postman',
      ' PostgreSQL',
    ],
  },
  /*
  {
    id: 1,
    img: 'https://github.com/juliaDooby/Clideo/blob/main/assets/images/skill-icons/oursource.JPG?raw=true',
    role: 'ReactJS Frontend developer',
    company: 'Webminds Studio.Pro',
    date: 'February 2020 — June 2021',
    desc: `
A web studio that provides outsourcing services for the development of web applications for businesses from different sectors.
·······················································································································································································
(Online video Editor) is a web application that allows users to create and edit videos with editing, formatting, layering and exporting functions in the desired format directly in the browser without installing additional programs, with support for all devices and formats. 
·······················································································································································································
Developed the interfaces and functionality of the website clideo.com , worked in a team with 3 frontends, 5 backends, 4 qa, 1 UI/UX, 1 Product Manager, 2 DevOps
·······················································································································································································
Progress:
┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈⏎
─ Redesigned key screens and optimized user flow: updated the main page, implemented a design system, hid irrelevant sections and ensured stylistic uniformity of interfaces
┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈
─ Carried out improvements and fixes in existing modules, including the elimination of UI failures and problems with data display
┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈
─ Organized secure client authentication using a Clerk for convenient UX access
┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈
─ Conducted a code review of tasks of medium complexity, including optimization of components (useMemo, memo, lazy) and integration of forms with validation and submission to the API
·······················································································································································································`,
    skills: [
      ' React',
      ' Javascript',
      ' Redux',
      ' Redux Toolkit',
      ' React-router-dom',
      ' Bootstrap-grid',
      ' HTML5',
      ' CSS3',
      ' CSS',
      ' SCSS',
      ' Axios',
      ' REST API',
      ' Webpack',
    ],
  },
*/]; 

export const projects = [
  {
    id: 0,
    title: 'Clideo',
    date: 'February 2020 - June 2021',
    description:
      'Developed the interfaces and functionality of the site "clideo.com ", worked in a team with: 3 frontends, 5 backends, 4 qa, 1 UI/UX, 1 Product Manager, 2 DevOps. We used the Scrum" methodology. I was engaged in writing new functionality, from a simple function to a new section, page on the site; Optimized and wrote the logic of UI components; Made improvements to existing functionality; Corrected errors, from changing content to fixing bugs when the application crashes; Conducted verification, code review of medium complexity; Participated in the creation of automatic tests of the project. The project was carried out for the EdTech-platform.',
    image:
      'https://github.com/juliaDooby/Clideo/blob/main/assets/images/Clideo.jpeg?raw=true',
      tags: [
      'React',
      'Javascript',
      'Redux',
      'Redux Toolkit',
      'React-router-dom',
      'Bootstrap-grid',
      'HTML5',
      'CSS3',
      'SCSS',
      'Axios',
      'Rest Api',
      'Webpack',
    ],
    category: 'web app',
    // github: '( NDA - no code )',
    webapp: 'https://clideo.com/ru',
    // member: [
    //   {
    //     name: '',
    //     img: '',
    //     linkedin: '',
    //     github: '',
    //   },
    //   {
    //     name: '',
    //     img: '',
    //     linkedin: '',
    //     github: '',
    //   },
    // ],
  },
  {
    id: 1,
    title: 'React-food-delivery-app',
    date: 'April 2021 - June 2021',
    description:
      'Website for accepting orders for food delivery and takeaway. Added the functionality of the shopping cart; The logic of filtering and sorting of goods; The product page itself; The shopping cart and the checkout page; The contact page; Used a modern minimalistic interface.',
    image:
      'https://github.com/juliaDooby/React-food-delivery-app/blob/main/FoodDeliveryShot1.JPG?raw=true',
    tags: ['React', 'Redux', 'Javascript', 'Css', 'Reactstrap', 'Tailwind CSS'],
    category: 'web app',
    github: 'https://github.com/juliaDooby/React-food-delivery-app',
    webapp: 'https://juliadooby.github.io/React-food-delivery-app/',
  },
  {
    id: 2,
    title: 'React-threads-app',
    date: 'April 2021 - June 2021',
    description:
      'Microblogging service and social network. Got used to Next.js 13.4 with server-side rendering; Studied MongoDB processing of complex schemes, multiple data filling; Created beautiful layouts using TailwindCSS; Used Clerk for authentication; Processed file uploads using UploadThing; Studied Shadcn components; Used real-time event listening using webhooks; Applied API actions and authorization; Used managed forms with a response form.',
    image:
      'https://github.com/juliaDooby/React-threads-app/blob/main/thread_1.JPG?raw=true',
    tags: [
      'React',
      'Typescript',
      'Nextjs',
      'Clerk',
      'Next.js13',
      'Next.js13-app-router',
      'MongoDB',
      'Mongoose',
    ],
    category: 'web app',
    github: ' https://github.com/juliaDooby/React-threads-app',
    webapp:
      'I apologize - In the process of correcting the server error related to the vercel deployment, I will make corrections as soon as possible',
  },
  {
    id: 3,
    title: 'React-chess-app',
    date: 'April 2021 - June 2021',
    description:
      'Chess game. Created the OOP classes for chess; Initialized the chess cage; Placed the pieces according to the coordinates of the board x y; Applied the selection of movable cells, wrote the logic of the game, the movement of the pieces (queen, bishop, rook), separately the movement of the knight and pawn; Created a list of eaten pieces, timer.',
    image:
      'https://github.com/juliaDooby/React-chess/blob/master/src/assets/Cover-chess.jpeg?raw=true',
    tags: ['React', 'Typescipt', 'Redux', 'Redux-toolkit'],
    category: 'web app',
    github: 'https://github.com/juliaDooby/React-chess',
    webapp: 'https://juliadooby.github.io/React-chess/',
  },
  {
    id: 4,
    title: 'React-gallery',
    image:
      'https://github.com/juliaDooby/React-gallery/blob/main/galleryShot.JPG?raw=true',
    description: 'Hand written ! component gallery, not! ready-made component from the library.',
    tags: ['Jsx', 'React', 'TypeScript', 'deploy vite'],
    category: 'web app',
    github: 'https://github.com/juliaDooby/React-gallery',
    webapp: 'https://wolf-gallery-indol.vercel.app',
  },
  {
    id: 5,
    title: 'React-music-app-2.0',
    image:
      'https://github.com/juliaDooby/React-music-app-2.0/blob/master/lyriks_5.JPG?raw=true',
    description:
      ' Master modern web development by building an improved version of Spotify Music-app-2.0 with: a modern homepage, fully-fledged music player, search, lyrics, song exploration features, search, popular music around you, worldwide top charts, and much more. What - i-ve done and used: React functional components and their reusability, React file and folder structure, Redux Toolkit to manage the state of application, mastery using Tailwind and make the app responsive on all devices, to fetch data from unlimited sources using RapidAPI. !-Unfortunately, the free Shazam Core Api was made paid and the link-demo to the visual interface is not available today.',
    tags: ['React.js', 'Redux Toolkit', 'RapidAPI - Shazam', 'CSS', 'Tailwind'],
    category: 'web app',
    github: 'https://github.com/juliaDooby/React-music-app-2.0',
    webapp: '',
  },
  {
    id: 6,
    title: 'React-Spotify-platform',
    image:
      'https://github.com/juliaDooby/React-Spotify-platform/blob/main/Spotify_4.JPG?raw=true',
    description:
      'Frontend: Creation of the NEXT project, Player location, Page with step-by-step track creation, File upload component, Player logic, Redux connection, next Redux wrapper, Typing PlayerReducer, Custom hooks useActions, useTypedSelector, Action creators, Working with the Audio object in the browser, playing a track, Custom hook using Input, Creating a track, requesting a server, sending files, SEO optimization, title, title, meta, Search for tracks, optimize search queries; Backend: Designing database diagrams. Service, Module, Modulator, Connect to the database, describe the data schema, , REST API, DTO, File upload, static distribution, FileService, CORS, completion of server development.',
    tags: [
      'React',
      'Redux',
      'Hooks',
      'Cors',
      'Typescript',
      'Rest-api',
      'Scss',
      'Nest',
      'Seo-optimization',
      'Next',
      'Useactions',
      'Axios-react',
    ],
    category: 'web app',
    github: 'https://github.com/juliaDooby/React-Spotify-platform',
    // webapp: '',
  },
  {
    id: 7,
    title: 'Travel-app',
    image:
      'https://github.com/juliaDooby/Travel-app/blob/main/travel_2.JPG?raw=true',
    description:
      'This is not just a simple landing page: an appealing hero section, a camp section featuring various camps to explore, an engaging travel guide section, a complex feature-rich section, a call to action section for mobile apps, and a big footer section with many site and social links. While developing the app, I: implemented Next.js 13 most modern best practices, improved code architecture and make components reusable, utilized Tailwind CSS, started with the mobile-first approach for maximum responsiveness, made use of TypeScript.',
    tags: ['React.js', 'Typescript', 'Next.js', 'TailwindCSS'],
    category: 'web app',
    github: 'https://github.com/juliaDooby/Travel-app/tree/main',
    // webapp: '',
  },
  {
    id: 8,
    title: 'Grilli-Restaurant',
    image: 'https://github.com/juliaDooby/Grilli-Restaurant/blob/main/Grilli_1.JPG?raw=true',
    description: 'Grilli is a fully responsive restaurant website',
    tags: ['HTML5', 'CSS3', 'Javascript'],
    category: 'js app',
    github: 'https://github.com/juliaDooby/Grilli-Restaurant',
    webapp: 'https://juliadooby.github.io/Grilli-Restaurant/',
  },
  {
    id: 9,
    title: 'Watch-shop',
    image: 'https://github.com/juliaDooby/Watch-shop/blob/main/Watch_1.JPG?raw=true',
    description: 'Watch Collection',
    tags: ['HTML5', 'CSS3', 'Javascript'],
    category: 'js app',
    github: 'https://github.com/juliaDooby/Watch-shop',
    webapp: 'https://juliadooby.github.io/Watch-shop/',
  },
  {
    id: 10,
    title: 'Website Rentiz',
    image:
      'https://github.com/juliaDooby/Rentiz/blob/main/RentizShot1.JPG?raw=true',
    description: 'Adaptive layout site for sale estate.',
    tags: ['HTML5', 'CSS3', 'Javascript', 'GSAP'],
    category: 'js app',
    github: 'https://github.com/juliaDooby/Rentiz',
    webapp: 'https://juliadooby.github.io/Rentiz/',
  },
  {
    id: 11,
    title: 'Interior-Haus',
    image: 'https://github.com/juliaDooby/Interior-Haus/blob/main/Interior_3.JPG?raw=true',
    description: 'Interior',
    tags: ['HTML5', 'CSS3', 'Javascript'],
    category: 'js app',
    github: 'https://github.com/juliaDooby/Interior-Haus',
    webapp: 'https://juliadooby.github.io/Interior-Haus/',
  },
  {
    id: 12,
    title: 'Hotel-Miranda',
    image: 'https://github.com/juliaDooby/Hotel-Miranda/blob/main/Hotel_1.JPG?raw=true',
    description: 'Hotel',
    tags: ['HTML5', 'CSS3', 'Javascript'],
    category: 'js app',
    github: 'https://github.com/juliaDooby/Hotel-Miranda',
    webapp: 'https://juliadooby.github.io/Hotel-Miranda/',
  },
  {
    id: 13,
    title: 'Travel-tour',
    image: 'https://github.com/juliaDooby/Travel-tour/blob/main/Tr-tour_1.JPG?raw=true',
    description: 'TravelTour',
    tags: ['HTML5', 'CSS3', 'Javascript'],
    category: 'js app',
    github: 'https://github.com/juliaDooby/Travel-tour',
    webapp: 'https://juliadooby.github.io/Travel-tour/',
  },
  {
    id: 14,
    title: 'JS.tasks-Set',
    image: 'https://github.com/juliaDooby/JS_task-set/blob/main/assets/images/cover-jsSet.jpg?raw=true',
    description: 'My personal selection for improving my programming skills and for potential blog development',
    tags: ['Javascript', 'Modern_standard-ES6+', 'React', 'Typescript', 'Vue',
    'Adaptive_layout', 'API_Integration', 'Array', 'Arrow_functions', 'async/await', 
    'Bind', 'Browser_API', 'Change_attribute', 'Closures', 'LiveCoding', 
    'Component_Concepts', 'DOM_manipulation', 'Destructuring', 'Event_handling', 'Event_loop',
    'Events', 'Execution_Context', 'Loop+Async', 'LoopTimeout', 'Modern_React-Tools', 
    'Modules', 'Objects', 'Optimizing_component-performance', 'Promises', 'React_Archit-approaches', 
    'React_Calculator', 'Todo-List', 'React_Components', 'React_Hooks', 'React_classnames',
    'React_styled-components', 'Req&Fetch', 'Rest_API', 'This'],
    category: 'js app',
    github: 'https://github.com/juliaDooby/JS_task-set/tree/main/Subject',
    webapp: 'https://github.com/juliaDooby/JS_task-set/tree/main',
  },
  {
    id: 15,
    title: 'Cost-calculator',
    image:
      'https://github.com/juliaDooby/Cost-calculator/blob/main/rentCarShot.JPG?raw=true',
    description:
      'The calculator calculates the total cost of the trip and displays information in the order field.',
    tags: ['HTML5', 'CSS3', 'Javascript'],
    category: 'js app',
    github: 'https://github.com/juliaDooby/Cost-calculator',
    webapp: 'https://juliadooby.github.io/Cost-calculator/',
  },
  {
    id: 16,
    title: 'Algoritms-Set',
    image: 'https://github.com/juliaDooby/JS_Algoritms/blob/main/assets/images/Cover-algoritms.jpg?raw=true',
    description: 'My personal selection for improving my programming skills and for potential blog development',
    tags: ['Javascript', 'Advert_campaign', 'Algorithm_Design-Principles', 'Anagrams', 'Basic_data-structure',
    'Binary_Search', 'Brackets', 'Calculate_LCM_GCD', 'Coin_exchange', 'Collection_of_signatures', 'Complex_algorithms',
    'Concerts', 'Count_inversions', 'Data_Access_Object-(DAO)', 'Data_transfer', 'Database_indexes_based_on-algorithms', 
    'Deep_Equal', 'Deep_cloning-objects', 'Deque', 'Dictionary', 'Divide_and_conquer', 'Dominant_element', 'Dynamic_progr',
    'Editing_distance', 'Encapsulation', 'Exchange', 'Fibonacci_Sequence', 'Graphs_nature', 'Graph', 'Graph_Representation',
    'Graph_connAlgo', 'Graph_traversals', 'Greedy_algorithms', 'HashMap', 'Hash_Search', 'Knapsack_problem', 'Linear_Search', 
    'Longest_Common-Subsequence', 'Matrix', 'Max_salary', 'MinPath_Graph', 'Modification_of_quicksort', 'Multitude', 'Number_of_prizes', 
    'Pair_of_nearby_points', 'Palindrome', 'Perimeter', 'Place_brackets', 'Priority_Queue', 'Queue_O(1)', 'Randomized_algorithms', 
    'Recursive_algorithms', 'Sequential_algorithms', 'Simple_algorithms', 'Simple_calculator', 'Singly_linked-list', 'Souvenirs',
    'Spices', 'Stack', 'TravNthTree'],
    category: 'js app',
    github: 'https://github.com/juliaDooby/JS_Algoritms/tree/main/Subject',
    webapp: 'https://github.com/juliaDooby/JS_Algoritms/tree/main',
  },
  {
    id: 17,
    title: 'Trello',
    image:
      'https://github.com/juliaDooby/Trello/blob/main/Trello_2.JPG?raw=true',
    description: 'Function of To-Do list: add new task, delete task.',
    tags: ['HTML5', 'CSS3', 'SCSS', 'Javascript'],
    category: 'js app',
    github: 'https://github.com/juliaDooby/Trello/tree/main',
    webapp: 'https://juliadooby.github.io/Trello/',
  },
  {
    id: 18,
    title: 'Responsive-contact-form',
    image:
      'https://github.com/juliaDooby/Responsive-contact-form/blob/main/validationFormShot.JPG?raw=true',
    description:
      'Feedback form: form validation. Made the appearance of the form. Adapted for mobile devices. Wrote a universal script in JS for validating form fields. This script will automatically determine that the field is being checked for validity. To do this, just add a custom attribute to the input in the HTML markup. If the frame value is incorrect, the input fields are highlighted in red, if correct - green. The form submit button only works if all fields are filled out correctly.',
    tags: ['HTML5', 'CSS3', 'Javascript', 'PHP'],
    category: 'js app',
    github: 'https://github.com/juliaDooby/Responsive-contact-form',
    webapp: 'https://juliadooby.github.io/Responsive-contact-form/',
  },
  {
    id: 19,
    title: 'Website Creative-scroll',
    image:
      'https://github.com/juliaDooby/Creative-scroll/blob/master/parallaxScrollShot.JPG?raw=true',
    description: 'Creative-scroll in parallax effect, (not adaptive for mobile !).',
    tags: ['HTML5', 'CSS3', 'Javascript', 'GSAP'],
    category: 'js app',
    github: 'https://github.com/juliaDooby/Creative-scroll',
    webapp: 'https://juliadooby.github.io/Creative-scroll/',  
  },
  {
    id: 20,
    title: 'Digital-Agency-PixelPulse',
    image: 'https://github.com/juliaDooby/Digital-Agency-PixelPulse/blob/main/Digital_1.JPG?raw=true',
    description: 'PixelPulse',
    tags: ['HTML5', 'CSS3', 'Javascript'],
    category: 'js app',
    github: 'https://github.com/juliaDooby/Digital-Agency-PixelPulse',
    webapp: 'https://juliadooby.github.io/Digital-Agency-PixelPulse/', 
  },
  {
    id: 21,
    title: 'StartUp WDM',
    image: 'https://github.com/juliaDooby/StartUp/blob/main/Startup_2.JPG?raw=true',
    description: 'StartUp',
    tags: ['HTML5', 'CSS3', 'Javascript'],
    category: 'js app',
    github: 'https://github.com/juliaDooby/StartUp',
    webapp: 'https://juliadooby.github.io/StartUp/',
  },
  {
    id: 22,
    title: 'Wood-zone',
    image: 'https://github.com/juliaDooby/Wood-zone/blob/main/Woodzone_4.JPG?raw=true',
    description: 'Best Seller',
    tags: ['HTML5', 'CSS3', 'Javascript'],
    category: 'js app',
    github: 'https://github.com/juliaDooby/Wood-zone',
    webapp: 'https://juliadooby.github.io/Wood-zone/',
  },
  {
    id: 23,
    title: 'Car-Serving',
    image: 'https://github.com/juliaDooby/Car-Serving/blob/main/Carserving_1.JPG?raw=true',
    description: 'Carserving',
    tags: ['HTML5', 'CSS3', 'Javascript'],
    category: 'js app',
    github: 'https://github.com/juliaDooby/Car-Serving',
    webapp: 'https://juliadooby.github.io/Car-Serving/', 
  },
  {
    id: 24,
    title: 'Job-hunt',
    image: 'https://github.com/juliaDooby/Job-hunt/blob/main/Jobhunt_2.JPG?raw=true',
    description: 'Job Hunt',
    tags: ['HTML5', 'CSS3', 'Javascript'],
    category: 'js app',
    github: 'https://github.com/juliaDooby/Job-hunt?tab=readme-ov-file',
    webapp: 'https://juliadooby.github.io/Job-hunt/',
  },
  {
    id: 25,
    title: 'Induz-Industry',
    image: 'https://github.com/juliaDooby/Induz-Industry/blob/main/Induz_3.JPG?raw=true',
    description: 'Industry',
    tags: ['HTML5', 'CSS3', 'Javascript'],
    category: 'js app',
    github: 'https://github.com/juliaDooby/Induz-Industry',
    webapp: 'https://juliadooby.github.io/Induz-Industry/',
  },
  {
    id: 26,
    title: 'The-Lights',
    image: 'https://github.com/juliaDooby/The-Lights/blob/main/Lights_1.JPG?raw=true',
    description: 'The-Lights',
    tags: ['HTML5', 'CSS3', 'Javascript'],
    category: 'js app',
    github: 'https://github.com/juliaDooby/The-Lights',
    webapp: 'https://juliadooby.github.io/The-Lights/',
  },
  {
    id: 27,
    title: 'Photographer-portfolio',
    image: 'https://github.com/juliaDooby/Photographer-portfolio/blob/main/Ptotogr_1.JPG?raw=true',
    description: 'Photo Portfolio',
    tags: ['HTML5', 'CSS3', 'Javascript'],
    category: 'js app',
    github: 'https://github.com/juliaDooby/Photographer-portfolio',
    webapp: 'https://juliadooby.github.io/Photographer-portfolio/',
  },
  {
    id: 28,
    title: 'Fashion-cataloque',
    image: 'https://github.com/juliaDooby/Fashion-cataloque/blob/main/Cataq_1.JPG?raw=true',
    description: 'Small Fashion Shop',
    tags: ['HTML5', 'CSS3', 'Javascript'],
    category: 'js app',
    github: 'https://github.com/juliaDooby/Fashion-cataloque',
    webapp: 'https://juliadooby.github.io/Fashion-cataloque/',
  },
  {
    id: 29,
    title: 'Pet-Place',
    image: 'https://github.com/juliaDooby/Pet-Place/blob/main/PetPlace_2.JPG?raw=true',
    description: 'Pet Products',
    tags: ['HTML5', 'CSS3', 'Javascript'],
    category: 'js app',
    github: 'https://github.com/juliaDooby/Pet-Place',
    webapp: 'https://juliadooby.github.io/Pet-Place/',
  },
  {
    id: 30,
    title: 'Furni-shop',
    image: 'https://github.com/juliaDooby/Furni-shop/blob/main/Furni_1.JPG?raw=true',
    description: 'Small Shop',
    tags: ['HTML5', 'CSS3', 'Javascript'],
    category: 'js app',
    github: 'https://github.com/juliaDooby/Furni-shop',
    webapp: 'https://juliadooby.github.io/Furni-shop/',
  },
 {
    id: 31,
    title: 'Crafti-handmade',
    image: 'https://github.com/juliaDooby/Crafti-handmade/blob/main/Craft_1.JPG?raw=true',
    description: 'Handmade',
    tags: ['HTML5', 'CSS3', 'Javascript'],
    category: 'js app',
    github: 'https://github.com/juliaDooby/Crafti-handmade',
    webapp: 'https://juliadooby.github.io/Crafti-handmade/',
  },
 {
    id: 32,
    title: 'Skywings-travel',
    image: 'https://github.com/juliaDooby/Skywings-travel/blob/main/Skywings_1.JPG?raw=true',
    description: 'Skywings',
    tags: ['HTML5', 'CSS3', 'Javascript'],
    category: 'js app',
    github: 'https://github.com/juliaDooby/Skywings-travel',
    webapp: 'https://juliadooby.github.io/Skywings-travel/',
  },
 {
  id: 33,
  title: 'Adex-Creative-agency',
    image: 'https://github.com/juliaDooby/Adex-Creative-agency/blob/main/Adex_1.JPG?raw=true',
    description: 'Business Agency Website',
    tags: ['HTML5', 'CSS3', 'Javascript'],
    category: 'js app',
    github: 'https://github.com/juliaDooby/Adex-Creative-agency',
    webapp: 'https://juliadooby.github.io/Adex-Creative-agency/',
  },
 {
    id: 34,
    title: 'Car-Rental',
    image: 'https://github.com/juliaDooby/Car-Rental/blob/main/CarRent_1.JPG?raw=true',
    description: 'Car Rental',
    tags: ['HTML5', 'CSS3', 'Javascript'],
    category: 'js app',
    github: 'https://github.com/juliaDooby/Car-Rental',
    webapp: 'https://juliadooby.github.io/Car-Rental/',
  },
 {
    id: 35,
    title: 'Lux-CarRent',
    image: 'https://github.com/juliaDooby/Lux-CarRent/blob/main/Luxcar_3.JPG?raw=true',
    description: 'Lux Rental',
    tags: ['HTML5', 'CSS3', 'Javascript'],
    category: 'js app',
    github: 'https://github.com/juliaDooby/Lux-CarRent',
    webapp: 'https://juliadooby.github.io/Lux-CarRent/',
  },
 {
    id: 36,
    title: 'Dprod-Digital-agency',
    image: 'https://github.com/juliaDooby/Dprod-Digital-agency/blob/main/readme-images/dprod-news.JPG?raw=true',
    description: 'Digital agency',
    tags: ['HTML5', 'CSS3', 'Javascript'],
    category: 'js app',
    github: 'https://github.com/juliaDooby/Dprod-Digital-agency',
    webapp: 'https://juliadooby.github.io/Dprod-Digital-agency/',
  },
 {
    id: 37,
    title: 'Flivan-flight',
    image: 'https://github.com/juliaDooby/Flivan-flight/blob/main/Flivan_3.JPG?raw=true',
    description: 'Flivan',
    tags: ['HTML5', 'CSS3', 'Javascript'],
    category: 'js app',
    github: 'https://github.com/juliaDooby/Flivan-flight',
    webapp: 'https://juliadooby.github.io/Flivan-flight/',
  },
 {
    id: 38,
    title: 'Photography-Studio',
    image: 'https://github.com/juliaDooby/Photography-Studio/blob/main/Capturer_1.JPG?raw=true',
    description: 'Photo Studio',
    tags: ['HTML5', 'CSS3', 'Javascript'],
    category: 'js app',
    github: 'https://github.com/juliaDooby/Photography-Studio',
    webapp: 'https://juliadooby.github.io/Photography-Studio/',
  },
  {
    id: 39,
    title: 'Industrial-Secttre',
    image: 'https://github.com/juliaDooby/Industrial-Secttre/blob/main/Indust_1.JPG?raw=true',
    description: 'Industrial Service',
    tags: ['HTML5', 'CSS3', 'Javascript'],
    category: 'js app',
    github: 'https://github.com/juliaDooby/Industrial-Secttre',
    webapp: 'https://juliadooby.github.io/Industrial-Secttre/',
  },
 {
    id: 40,
    title: 'Pacman-game',
    image: 'https://github.com/juliaDooby/Pacman-game/blob/main/Pacman_1.JPG?raw=true',
    description: 'Pacman-game',
    tags: ['HTML5', 'CSS3', 'Javascript'],
    category: 'js app',
    github: 'https://github.com/juliaDooby/Pacman-game',
    webapp: 'https://juliadooby.github.io/Pacman-game/',
  },
  // {
  //   id: 42,  
  //   title: 'Quiz - Guess the number',
  //   description: 'Guess the secret number.',
  //   image:
  //     'https://github.com/juliaDooby/Guess-the-number/blob/main/QuizShot.JPG?raw=true',
  //   tags: ['HTML5', 'CSS3', 'Javascript'],
  //   category: 'js app',
  //   github: 'https://github.com/juliaDooby/Guess-the-number',
  //   webapp: 'https://juliadooby.github.io/Guess-the-number/',
  // },
 {
    id: 41,
    title: 'Stardust',
    image: 'https://github.com/juliaDooby/Stardust/blob/main/Stardust_1.JPG?raw=true',
    description: 'Vanilla JS with parallax effect',
    tags: ['HTML5', 'CSS3', 'Javascript'],
    category: 'js app',
    github: 'https://github.com/juliaDooby/Stardust?tab=readme-ov-file#technologies-used',
    webapp: 'https://juliadooby.github.io/Stardust/',
  },
];

export const TimeLineData = [
  // { year: 2017, text: 'Started my journey' },
  // { year: 2018, text: 'Worked as a freelance developer' },
  // { year: 2019, text: 'Founded JavaScript Mastery' },
  // { year: 2020, text: 'Shared my projects with the world' },
  // { year: 2021, text: 'Started my own platform' },
];
